import { Component, HostListener, Input, OnInit } from '@angular/core';
import { switchMap, tap } from 'rxjs';
import { AnchorModel } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NodeService } from 'src/app/shared/services/node.services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-page-evento',
  templateUrl: './page-evento.component.html',
  styleUrls: ['./page-evento.component.scss'],
})
export class PageEventoComponent implements OnInit {
  @Input() node: any;
  @Input() anchorItems: AnchorModel[] = [];
  @Input() isSecondLevelUp: boolean = false;
  public relatedEvents: any[] = [];
  public idAnchor: string = '';
  public block: any;
  public imgPath = '';
  public imgAlt = '';
  public isSpinner: boolean = false;
  public domainWebsite = environment.urlApi;
  public titlePage: string = '';
  public startEvent: string = '';
  public endEvent: string = '';
  public isCollapseHeader: boolean = false;
  public isShowLocalMenu: any;
  public dataFieldTaxonomies: any[] = [];
  //MODALE SHARE
  public onHoverShare: boolean = false;
  public today = new Date();

  constructor(
    private helpersService: HelpersService,
    public nodeService: NodeService
  ) {}

  ngOnInit(): void {
    if (this.node.type[0].target_id === 'archivio_evento') {
      this.block = this.node;
      this.titlePage = this.block.title[0].value;
      this.startEvent = this.block.field_data_inizio[0].value;
      this.endEvent = this.block.field_data_fine[0].value;
      if (this.helpersService.isBrowser) {
        setTimeout(() => {
          document.querySelectorAll('a').forEach((anchor) => {
            if (anchor.href.indexOf('backoffice.lumsa.it') >= 0) {
              anchor.addEventListener(
                'click',
                (event) => {
                  event.preventDefault();
                  let element: any = event.srcElement;
                  if (
                    element.tagName != 'A' &&
                    element.parentElement.tagName == 'A'
                  ) {
                    element = element.parentElement;
                  }
                  window.open('https://lumsa.it' + element.pathname, '_blank');
                },
                false
              );
            }
          });
        }, 500);
      }
    } else {
      this.nodeService
        .getRowTypeView(
          this.node.langcode[0].value,
          this.node.field_oggetto_view[0].value,
          this.node.field_tipo_view[0].value,
          this.node.preview,
          this.node.nid[0].value
        )
        .pipe(
          tap((resView) => {
            this.block = resView[0];
            this.setDataFields(this.block);
            this.imgPath =
              this.domainWebsite +
              this.helpersService.retrieveImage(
                this.block.field_immagine,
                'src'
              );
            this.imgAlt = this.helpersService.retrieveImage(
              this.block.field_immagine,
              'alt'
            );
            this.titlePage = this.helpersService.retriveLinkTagA(
              this.block.field_titolo,
              'a'
            ).title;
            this.startEvent = this.helpersService.retrieveDateTime(
              this.block.field_data_inizio,
              'datetime'
            );
            this.endEvent = this.helpersService.retrieveDateTime(
              this.block.field_data_fine,
              'datetime'
            );
          }),
          switchMap((nodeEvents) =>
            this.nodeService.getRelatedViewEvents(
              this.node.langcode[0].value,
              this.node.field_oggetto_view[0].value,
              nodeEvents[0].field_tassonomia_area_universita,
              this.node.nid[0].value,
              this.node.preview
            )
          )
        )
        .subscribe((relatedEvents) => {
          let temp: any[] = [];
          relatedEvents.forEach((element: any) => {
            const elementDateEnd = this.helpersService.retrieveDateTime(
              element.field_data_fine_export,
              'datetime'
            );
            if (new Date(elementDateEnd) >= this.today) {
              temp.push(this.helpersService.transformResultsExport(element));
            }
          });
          if (temp.length > 6) {
            for (let idx = 0; idx < 6; idx++) {
              this.relatedEvents.push(temp[idx]);
            }
          } else {
            this.relatedEvents = temp;
          }
        });
    }
    this.isSpinner = true;
    this.helpersService.showLocalMenuBS.subscribe((value) => {
      this.isShowLocalMenu = value;
    });
  }

  @HostListener('document:scroll', ['$event'])
  public onViewportScroll() {
    let boundingCollapse;
    if (this.isSpinner && this.node) {
      boundingCollapse = document
        .querySelector('.container-field-taxonomies')
        ?.getBoundingClientRect();
    }
    if (
      (boundingCollapse &&
        boundingCollapse.y < -40 &&
        boundingCollapse.width > 767) ||
      (boundingCollapse &&
        boundingCollapse.y < -200 &&
        boundingCollapse.width <= 767)
    ) {
      this.isCollapseHeader = true;
    } else {
      this.isCollapseHeader = false;
    }
  }

  addNewAnchorItem(value: AnchorModel) {
    if (value.labelRow !== '') {
      this.anchorItems.push(value);
    }
    this.anchorItems.sort((a, b) => a.position - b.position);
    // this.idAnchor = this.anchorItems[0].idRow;
  }

  public openMenu(): void {
    this.helpersService.openLocalMenuBS.next(true);
  }

  private setDataFields(block: any): void {
    if (block.field_tassonomia_dipartimento.length) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_EVENTO.DEPARTMENT',
          value: block.field_tassonomia_dipartimento,
          isArray: true,
        },
      ];
    }
    if (block.field_tassonomia_area_universita.length) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_FAQ.UNIVERSITY_AREAS',
          value: block.field_tassonomia_area_universita,
          isArray: true,
        },
      ];
    }
    if (block.field_tassonomia_corsi_di_laurea.length) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_EVENTO.DEGREE_COURSES',
          value: block.field_tassonomia_corsi_di_laurea,
          isArray: true,
        },
      ];
    }
    if (block.field_tags.length) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_EVENTO.TAG',
          value: block.field_tags,
          isArray: true,
        },
      ];
    }
  }

  public stringToDate(str: string): Date {
    return new Date(str);
  }
}
